module.exports = __webpack_public_path__ + "fonts/Rubik-Bold.d6173c4.ttf";